module.exports = __webpack_public_path__ + "static/media/header_bg.25b97558.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/header_bg.jpg
// module id = 133
// module chunks = 0